import React, { useState } from "react";
import Card from "app/popleads/components/ui-kit/Card";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { DEAL_CANCELLED, DEAL_LOST, DEAL_WON, POPUP_CONTENTS } from "../utils/constants";
import { useExtensionContext } from "../ExtensionContext";
import { FormattedNumber } from "react-intl";
import styled from "styled-components";
import { ExtensionBody, ExtensionSmall } from "app/popleads/components/ui-kit/Text";
import { colors } from "app/popleads/components/ui-kit/colors";
import ExtensionDealTabs from "../ExtensionDealTabs";
import { toast } from "react-toastify";
import { getDealName } from "../utils/deal-utils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const StyledCardContent = styled(ExtensionBody)`
    color: ${colors.neutral[800]};
    display: -webkit-box !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-word;
    overflow: hidden;
`;
const StyledWonAmount = styled(ExtensionBody)`
    color: #00856c;
`;
const StyledCardFooter = styled(ExtensionSmall)`
    color: ${colors.neutral[500]};
    display: flex;
    font-size: 11px;
`;
const StyledFlexContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const StyledTooltip = styled(Tooltip)`
    .tooltip-inner {
        font-size: 11px !important;
    }
`;

const ExtensionDealCard = () => {
    const {
        profile,
        setState,
        popit,
        setSelectedDeal,
        setDealObject,
        initialDealObject,
        collapsedCards,
        setCollapsedCard,
        dealsLoading,
        dealRef,
    } = useExtensionContext();
    const [selectedTabs, setSelectedTabs] = useState(DEAL_WON);
    const collapsed = collapsedCards.deal;
    const handleCollapseChange = (val) => {
        setCollapsedCard("deal", val);
    };
    let inProgressDealAmount = 0;
    let wonDealAmount = 0;

    if (profile?.olanak) {
        for (let i = 0; i < profile.olanak.length; i++) {
            const olanak = profile.olanak[i];
            const durum = olanak.durum?.toLowerCase();
            const totalAmount = Number(olanak.totalAmount) || 0;

            if (
                durum !== DEAL_WON.toLowerCase() &&
                durum !== DEAL_LOST.toLowerCase() &&
                durum !== DEAL_CANCELLED.toLowerCase()
            ) {
                inProgressDealAmount += totalAmount;
            } else if (durum === DEAL_WON.toLowerCase()) {
                wonDealAmount += totalAmount;
            }
        }
    }
    const dealList = profile?.olanak
        ?.filter((olanak) => {
            const durum = olanak.durum?.toLowerCase();
            if (selectedTabs.toLowerCase() === DEAL_WON.toLowerCase()) {
                return durum === DEAL_WON.toLowerCase();
            } else if (selectedTabs.toLowerCase() === "in progress") {
                return (
                    durum !== DEAL_WON.toLowerCase() &&
                    durum !== DEAL_LOST.toLowerCase() &&
                    durum !== DEAL_CANCELLED.toLowerCase()
                );
            } else {
                return durum === selectedTabs.toLowerCase();
            }
        })
        .sort((a, b) => (Number(b.totalAmount) || 0) - (Number(a.totalAmount) || 0))
        .map((olanak) => {
            return {
                //icon: <SVG src={toAbsoluteUrl("/media/svg/popleads/money_bag.svg")} />,
                /*header: (
                    <StyledFlexContainer>
                        <OverlayTrigger placement="top" overlay={<StyledTooltip>Created Date</StyledTooltip>}>
                            <span>
                                <StyledCardHeader>{moment(olanak.createdTime).format("MMM DD, YYYY")}</StyledCardHeader>
                            </span>
                        </OverlayTrigger>
                    </StyledFlexContainer>
                )*/
                content: (
                    <StyledFlexContainer>
                        <OverlayTrigger placement="top" overlay={<StyledTooltip>{getDealName(olanak)}</StyledTooltip>}>
                            <StyledCardContent>{getDealName(olanak)}</StyledCardContent>
                        </OverlayTrigger>
                        <StyledWonAmount>
                            $
                            <FormattedNumber
                                minimumFractionDigits={0}
                                maximumFractionDigits={2}
                                value={olanak.totalAmount}
                            />
                        </StyledWonAmount>
                    </StyledFlexContainer>
                ),
                footer: (
                    <StyledCardFooter>
                        {`${olanak?.ad}${
                            olanak?.ad && olanak?.dealCampaignType ? " | " : ""
                        }${olanak?.dealCampaignType || ""}`}
                    </StyledCardFooter>
                ),
                onClick: () => {
                    setSelectedDeal(olanak);
                    setState({ popupContent: POPUP_CONTENTS.DEALS, popupIsOpen: true });
                },
            };
        });

    return (
        <div ref={dealRef} style={{ padding: "12px 0px", borderBottom: "1px solid rgb(225, 225, 225)" }}>
            <Card
                isLoading={dealsLoading}
                iconWidth="0px"
                homePage={true}
                collapsed={collapsed}
                onCollapseChange={handleCollapseChange}
                cardTitle={profile?.olanak?.length > 0 ? "Deals (" + profile.olanak.length + ")" : "Deals"}
                cardTitleOnClick={() => {
                    if (popit) {
                        toast.warning("You need to POP the profile first.");
                    } else {
                        setState({ popupContent: POPUP_CONTENTS.DEALS, popupIsOpen: true });
                    }
                }}
                component={
                    <ExtensionDealTabs
                        wonDealAmount={wonDealAmount}
                        inProgressDealAmount={inProgressDealAmount}
                        selectedTabs={selectedTabs}
                        setSelectedTabs={setSelectedTabs}
                    />
                }
                button={
                    <ButtonWithText
                        label="Add deal"
                        icon="add"
                        onClick={() => {
                            if (popit) {
                                toast.warning("You need to POP the profile first.");
                            } else {
                                setState({ popupContent: POPUP_CONTENTS.NEW_DEAL, popupIsOpen: true });
                                setDealObject(initialDealObject);
                            }
                        }}
                        iconType="material"
                        variant="l3rnTech"
                        buttonStyle="default"
                        size="circle"
                    />
                }
                cardItems={dealList}
                viewMoreOnClick={() => {
                    setState({ popupContent: POPUP_CONTENTS.DEALS, popupIsOpen: true });
                }}
                errorDescription="Click the + to create a deal."
            />
        </div>
    );
};

export default ExtensionDealCard;
